export default function SectionTitle({ subtitle, title, text, align = "center", light }) {
  return (
    <div className={`sec-head ${align === "left" ? "left" : ""}`}>
      {subtitle && <span className="subtitle">{subtitle}</span>}
      {title && (
        <h2 className="sec-title" dangerouslySetInnerHTML={{ __html: title }} />
      )}
      {text && <p className="sec-text">{text}</p>}
    </div>
  );
}
